import React, {
  Ref,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import { fields1, fields2 } from "./config";
import { Button, Col, DatePicker, Form, Row, Space, Tooltip } from "antd";
import { convertIosStringToDateDayjs } from "helper/common";
import { InputFields } from "components/common";
import "./EditorConvertToJSON.scss";
import { fontOptions, initialContent } from "./TextEditor";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromHTML,
  convertFromRaw,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { PauseCircleOutlined, PlayCircleOutlined } from "@ant-design/icons";
import { FORMAT_TIME, tabKeys } from "types/enums";
import dayjs from "dayjs";
import electrocardiographyService from "api/electrocardiography";
import Notification from "components/common/notification/notification";
import { valueType } from "antd/es/statistic/utils";
import { OptionProps } from "antd/es/select";
import { useAppDispatch, useAppSelector } from "redux/hooks";

export type ElectrocardiographyInfoRef = {
  getFormValue: () => any;
  setFieldValue: (name, value) => void;
};

type Props = {
  electrocardiographyInfo: any;
  ref?: Ref<ElectrocardiographyInfoRef>;
};

const ElectrocardiographyInfo = React.forwardRef<
  ElectrocardiographyInfoRef,
  Props
>((props, ref) => {
  const { electrocardiographyInfo } = props;
  const patientRef = useAppSelector((e) => e.electrocardiography.patientRef);

  const [form] = Form.useForm();
  const [start, setStart] = useState(true);
  const [listDT, setListDT] = useState([]);
  const [nguoiDocKetQua, setNguoiDocKetQua] = useState(null);

  const [editorState, setEditorState] = useState(
    EditorState.createWithContent(convertFromRaw(initialContent))
  );
  const activeTab = useAppSelector((e) => e.common.activeTab);

  const [fields, setFields] = useState(fields1);
  const [options, setOptions] = useState(null);
  const mauDienTim = Form.useWatch("mauDienTim", form);
  useMemo(() => {
    if (listDT && listDT.length > 0) {
      const res = listDT.find((e) => e.id === mauDienTim)?.tenNguoiDocKQ;
      console.log("🚀 ~ useMemo ~ res:", res);
    }
  }, [mauDienTim]);
  const getLisElectroCardiographyCatalog = async () => {
    try {
      const res =
        await electrocardiographyService.getLisElectroCardiographyCatalog();
      setListDT(res);
      const options = await res.map((i) => {
        return { value: i.id, label: i.tenMauDienTim } || [];
      });

      fields.find((e) => e.name === "mauDienTim").options = options;
      fields.find((e) => e.name === "mauDienTim").onChange = (e, o) =>
        handleChangeElectrodiography(e, o, res);

      setOptions(res);
      setFields([...fields]);
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy mẫu điện tim");
    }
  };
  // useEffect(() => {
  //   fields.find((e) => e.name === "nguoiDocKetQua").onChange = (e) =>
  //     patientRef.setFieldValue("nguoiDocKetQua", e.target.value);

  //   setFields([...fields]);
  // }, [patientRef]);
  useEffect(() => {
    if (tabKeys.ELECTROCARDIOGRAPHY.DETAIL_INFO_ELECTRO) {
      getLisElectroCardiographyCatalog();
    }
  }, [activeTab]);

  useEffect(() => {
    if (!electrocardiographyInfo?.moTa && options) {
      const blockFromHTMl = convertFromHTML(
        options?.find((e) => e.id === 2).moTa
      );
      const state = ContentState.createFromBlockArray(
        blockFromHTMl.contentBlocks,
        blockFromHTMl.entityMap
      );
      setEditorState(EditorState.createWithContent(state));
    } else if (electrocardiographyInfo?.mauDienTim) {
      if (electrocardiographyInfo?.moTa) {
        const blockFromHTMl = convertFromHTML(electrocardiographyInfo?.moTa);
        const state = ContentState.createFromBlockArray(
          blockFromHTMl.contentBlocks,
          blockFromHTMl.entityMap
        );
        setEditorState(EditorState.createWithContent(state));
      }
    } else
      setEditorState(
        EditorState.createWithContent(convertFromRaw(initialContent))
      );
  }, [options, electrocardiographyInfo]);

  useEffect(() => {
    form.setFieldsValue({
      ...electrocardiographyInfo,

      thoiGianBatDau: convertIosStringToDateDayjs(
        electrocardiographyInfo?.thoiGianBatDau
      ),
      thoiGianKetThuc: convertIosStringToDateDayjs(
        electrocardiographyInfo?.thoiGianKetThuc
      ),
      ketLuan: electrocardiographyInfo?.ketLuan ?? "Bình thường",
      // nguoiDocKetQua:
      //   electrocardiographyInfo?.nguoiDocKetQua != "" &&
      //   electrocardiographyInfo?.nguoiDocKetQua
      //     ? electrocardiographyInfo?.nguoiDocKetQua
      //     : "Đàm Văn Quý",
      mauDienTim: electrocardiographyInfo?.mauDienTim ?? 2,
    });
  }, [electrocardiographyInfo]);

  // useEffect(() => {
  //   form.setFieldsValue({
  //     mauDienTim: 2,
  //   });
  // }, [options]);

  const onEditorStateChange = useCallback((editorState) => {
    setEditorState(editorState);
  }, []);

  function handleChangeElectrodiography(
    id: valueType,
    o: OptionProps,
    options
  ) {
    const selectedData = options.find((item: any) => {
      return item.id === id;
    });

    const blockFromHTMl = convertFromHTML(selectedData?.moTa);
    const state = ContentState.createFromBlockArray(
      blockFromHTMl.contentBlocks,
      blockFromHTMl.entityMap
    );
    setEditorState(EditorState.createWithContent(state));
  }
  //set lai value

  const formatFormValue = () => {
    const rawValues = form.getFieldsValue();

    const formatValues = {
      ...rawValues,
      moTa: editorState
        ? draftToHtml(convertToRaw(editorState.getCurrentContent()))
        : "",
    };
    return formatValues;
  };

  useImperativeHandle(ref, () => ({
    getFormValue: () => {
      return formatFormValue();
    },
    setFieldValue: (name, value) => {
      form.setFieldValue(name, value);
    },
    nguoiDocKetQua:
      nguoiDocKetQua ?? listDT.find((e) => e.id === 2)?.tenNguoiDocKQ,
  }));
  const handleStart = () => {
    setStart(false);
    form.setFieldValue("thoiGianBatDau", dayjs());
  };

  const handleEnd = () => {
    setStart(true);
    form.setFieldValue("thoiGianKetThuc", dayjs());
  };

  return (
    <div className="patient-info">
      <Form labelAlign="left" form={form}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Row gutter={[16, 16]}>
            <Col xl={11} lg={11}>
              <Form.Item
                name={"thoiGianBatDau"}
                label="Thời gian bắt đầu"
                labelCol={{ xl: 7, lg: 8, md: 6, sm: 8 }}
                wrapperCol={{ xl: 17, lg: 16, md: 18, sm: 16 }}
              >
                <DatePicker
                  style={{
                    width: "100%",
                  }}
                  format={`${FORMAT_TIME.dateTime}`}
                  showTime={true}
                  disabledDate={(current) => {
                    return current && current.valueOf() > Date.now();
                  }}
                />
              </Form.Item>
            </Col>
            <Col
              xl={2}
              lg={2}
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Tooltip title={start ? "Bắt đầu điện tim" : "Kết thúc điện tim"}>
                <Button
                  style={{ width: "50%" }}
                  icon={
                    start ? (
                      <PlayCircleOutlined onClick={handleStart} />
                    ) : (
                      <PauseCircleOutlined onClick={handleEnd} />
                    )
                  }
                />
              </Tooltip>
            </Col>
            <Col xl={11} lg={11}>
              <Form.Item
                name={"thoiGianKetThuc"}
                label="Thời gian kết thúc"
                labelCol={{ xl: 6, lg: 8, md: 6, sm: 8 }}
                wrapperCol={{ xl: 18, lg: 16, md: 18, sm: 16 }}
              >
                <DatePicker
                  style={{
                    width: "100%",
                  }}
                  format={`${FORMAT_TIME.dateTime}`}
                  showTime={true}
                  disabledDate={(current) => {
                    return current && current.valueOf() > Date.now();
                  }}
                />
              </Form.Item>
            </Col>
            <InputFields data={fields} />
          </Row>
          <Row style={{ width: "100%" }}>
            <Col xl={24} className="editor">
              <Form.Item
                label="Mô tả"
                name={"moTa"}
                labelCol={{ xl: 3 }}
                wrapperCol={{ xl: 21 }}
              >
                <Editor
                  editorState={editorState}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  onEditorStateChange={onEditorStateChange}
                  toolbar={fontOptions}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <InputFields data={fields2} />
          </Row>
        </Space>
      </Form>
    </div>
  );
});
export default ElectrocardiographyInfo;
